import { render, staticRenderFns } from "./JumpMarks.vue?vue&type=template&id=167f6166&"
import script from "./JumpMarks.vue?vue&type=script&lang=js&"
export * from "./JumpMarks.vue?vue&type=script&lang=js&"
import style0 from "./JumpMarks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports